import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dropdownentry',
  templateUrl: './dropdownentry.component.html',
  styleUrls: ['./dropdownentry.component.css']
})
export class DropdownentryComponent implements OnInit {
  @Input() dropdownentry: FormGroup;
  @Input() index: number;
  @Input() last: number;
  @Output() delete = new EventEmitter<number>();
  @Output() moveEntry = new EventEmitter<object>();

  constructor() { }

  ngOnInit(): void {
  }

  onSort(data: number) {
    this.moveEntry.emit({
      index: this.index,
      direction: data
    });
  }

  onDelete() {
    this.delete.emit(this.index);
  }

  get seq() {
    return this.dropdownentry.get('seq').value;
  }
}
